import React, { useState, Fragment } from 'react';
import { Tooltip as ReactTooltipLib } from 'react-tooltip';
import { Tooltip } from 'reactstrap';
import { createPortal } from 'react-dom';
import { isStringHasHTMLTags } from 'helpers';
import NewDesign from 'components/NewDesign';
import { cn } from 'helpers/css';

import {
  Tooltip as TooltipShadcn,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'shadcn/components/tooltip';

const TooltipReactStrap = (props) => {
  const { placement, idTarget, messageToolTip, children } = props;
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <div className='dzb-tooltip'>
      <div id={idTarget}>{children}</div>
      <Tooltip placement={placement} isOpen={tooltipOpen} target={idTarget} toggle={toggle}>
        {messageToolTip}
      </Tooltip>
    </div>
  );
};

TooltipReactStrap.defaultProps = {
  placement: 'right',
  idTarget: 'example',
  messageToolTip: '',
};

// Recommend use
// Guide: https://www.npmjs.com/package/react-tooltip

//* Use with react-virtualized
export const rebuildTooltip = () => {};

export const TooltipReactTooltip = ({
  idTarget,
  children,
  messageToolTip,
  place = 'top',
  delayShow = 0,
  style,
  classNameContainer = '',
  asChild,
  v2 = true,
  v2Options,
}) => {
  if (v2) {
    return (
      <TooltipProvider>
        <TooltipShadcn delayDuration={0}>
          <TooltipTrigger
            type='button'
            className={v2Options?.className}
            asChild={asChild}
            // TEX-333: Radix opens a tooltip on focus as well as on hover, so when a popover
            // closes and hands focus back to its trigger the tooltip pops up on its own. Only a
            // keyboard focus (:focus-visible) may open it; a programmatic or mouse-born focus is
            // ignored (preventDefault stops Radix's composed onFocus handler).
            onFocus={(e) => {
              const el = e.currentTarget;
              if (!(el && typeof el.matches === 'function' && el.matches(':focus-visible'))) {
                e.preventDefault();
              }
            }}
          >
            {children}
          </TooltipTrigger>
          <TooltipContent side={v2Options?.side}>{messageToolTip}</TooltipContent>
        </TooltipShadcn>
      </TooltipProvider>
    );
  }

  const [show, setShow] = useState(false);
  const messageShow = isStringHasHTMLTags(messageToolTip) ? (
    <NewDesign.Typography dangerouslySetInnerHTML={{ __html: messageToolTip }} />
  ) : (
    messageToolTip
  );

  const renderTooltipInPortal = createPortal(
    <ReactTooltipLib
      isOpen={show}
      anchorSelect={`#${idTarget}`}
      delayShow={delayShow}
      place={place}
      style={{
        zIndex: 9999,
      }}
    >
      {messageShow}
    </ReactTooltipLib>,
    document.body
  );

  return (
    <Fragment>
      <NewDesign.Typography
        id={idTarget}
        style={style}
        className={cn(classNameContainer, 'copy-icon')}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
      >
        {children}
      </NewDesign.Typography>

      {renderTooltipInPortal}
    </Fragment>
  );
};

export default TooltipReactStrap;
